export default "__VITE_ASSET__BTuaDqj0__"